import { BADGE_STATUSES, PRE_TORK_STATUSES, statusLabel, statusColor } from "./constants";

const fmt = (d) => d ? new Date(d).toLocaleString("sv-SE") : "–";

/* Shows the orderLogs for a single order entry, plus status management. */
const OrderHistoryModal = ({ order, onClose, onStatusChange }) => {
    if (!order) return null;

    // A pre-tork order can only move between the pre-tork statuses (starting the
    // tork goes through the start form), once started it follows the badge cycle.
    // A closed order is archived — the history view is read-only for it.
    const statusOptions = order.status === "closed"
        ? []
        : PRE_TORK_STATUSES.includes(order.status)
            ? PRE_TORK_STATUSES
            : BADGE_STATUSES;

    return (
        <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50 p-4" onClick={onClose}>
            <div className="bg-white rounded-lg shadow-xl w-full max-w-lg max-h-[90vh] overflow-y-auto p-6" onClick={e => e.stopPropagation()}>
                <div className="flex justify-between items-center mb-4">
                    <div>
                        <h2 className="text-xl font-semibold">Historik</h2>
                        <p className="text-sm text-gray-500">
                            Order {order.orderId} · {order.type}
                        </p>
                    </div>
                    <button onClick={onClose}
                        className="text-gray-400 hover:text-gray-600 text-2xl leading-none">×</button>
                </div>

                {/* Comment */}
                {order.comment && (
                    <div className="mb-4 flex items-start gap-2 bg-yellow-50 border border-yellow-200 rounded-lg px-3 py-2 text-sm text-gray-700">
                        <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4 mt-0.5 text-yellow-500 shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                            <path strokeLinecap="round" strokeLinejoin="round" d="M7 8h10M7 12h6m-6 4h8M5 4h14a2 2 0 012 2v10a2 2 0 01-2 2H7l-4 4V6a2 2 0 012-2z" />
                        </svg>
                        <span>{order.comment}</span>
                    </div>
                )}

                {/* Status management */}
                {statusOptions.length > 0 && (
                <div className="mb-4">
                    <p className="text-sm font-medium text-gray-700 mb-2">Ändra status</p>
                    <div className="flex flex-wrap gap-2">
                        {statusOptions.map(status => (
                            <button
                                key={status}
                                onClick={() => onStatusChange(order.id, status)}
                                className={
                                    "px-3 py-1 rounded-full text-xs border transition " +
                                    (order.status === status
                                        ? statusColor(status) + " border-transparent font-semibold"
                                        : "bg-white text-gray-600 border-gray-300 hover:bg-gray-100")
                                }
                            >
                                {statusLabel(status)}
                            </button>
                        ))}
                    </div>
                </div>
                )}

                {/* Log entries */}
                <div>
                    <p className="text-sm font-medium text-gray-700 mb-2">Logg</p>
                    {(order.orderLogs || []).length === 0 && (
                        <p className="text-sm text-gray-400">Inga loggar.</p>
                    )}
                    <ul className="space-y-2">
                        {(order.orderLogs || []).slice().reverse().map((log, i) => (
                            <li key={i}
                                className="flex gap-3 text-sm bg-gray-50 rounded px-3 py-2 border">
                                <span className="text-gray-400 whitespace-nowrap shrink-0">
                                    {fmt(log.timestamp)}
                                </span>
                                <span className="flex-1">
                                    {log.status && (
                                        <span className={"mr-2 px-2 py-0.5 rounded-full text-xs " + statusColor(log.status)}>
                                            {statusLabel(log.status)}
                                        </span>
                                    )}
                                    {log.comment && <span className="text-gray-700">{log.comment}</span>}
                                    {log.actor && (
                                        <span className="text-gray-400 ml-1">({log.actor})</span>
                                    )}
                                </span>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default OrderHistoryModal;
